import React from 'react';

export default class Modal extends React.Component {
  state = {
    style: {}
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    setTimeout(() => this.setState({ style: { transform: 'none', opacity: 1 } }), 0);
  }

  onClose = () => this.setState({ style: {} }, () => setTimeout(() => this.props.history.goBack(),  500))

  render() {
    return (
      <div style={{ transition: 'all 0.5s', width: '100vw', minHeight: '100vh', ...this.state.style }} className="profile-modal">
        {this.props.children}
        <img src="/cross.png" className="cross" onClick={this.onClose} alt="close" />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Modal.js